import dispatcher from '../dispatcher';
import popupCloseProto from '../popup/popup-close.component';
import * as cookieUtils from '../utils/cookieUtils';

var elementProto = Object.create(HTMLButtonElement.prototype);

var _setCookie = function() {
	cookieUtils.set('specialist', 'true', 30);
}

elementProto.createdCallback = function() {
	this.setCookie = _setCookie.bind(this);

	popupCloseProto.createdCallback.apply(this);
}
elementProto.attachedCallback = function() {
	this.addEventListener('click', this.setCookie);

	popupCloseProto.attachedCallback.apply(this);
}
elementProto.detachedCallback = function() {
	popupCloseProto.detachedCallback.apply(this);
}

document.registerElement('specialist-button', {
	prototype: elementProto,
	extends: 'button'
});